import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import DynamicDataViewer from './DynamicDataViewer';

const InteractionDetailModal = ({ isOpen, toggle, interaction }) => {
  if (!interaction) return null;

  const { tipo, datiParsed } = interaction;

  return (
    <Modal isOpen={isOpen} toggle={toggle} style={{ maxWidth: '1200px' }}>
      <ModalHeader toggle={toggle}>Dettaglio</ModalHeader>
      <ModalBody>
        {datiParsed != null &&
        (typeof datiParsed !== 'object' ||
          Object.keys(datiParsed).length > 0) ? (
          <DynamicDataViewer data={datiParsed} depth={1} maxDepth={3} />
        ) : (
          <p>Nessun dato disponibile</p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Chiudi
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default InteractionDetailModal;
